<form #dateFilterForm="ngForm" class="filter-row start-center flex-row">
    <cb-datepicker
        label="Date From"
        name="dateFrom"
        [(ngModel)]="dateFrom"
        (change)="cleanSearch()"
    ></cb-datepicker>
    <cb-datepicker
        label="Date To"
        name="dateTo"
        [(ngModel)]="dateTo"
        (change)="cleanSearch()"
    ></cb-datepicker>
    <mat-icon> search </mat-icon>
    <cb-select
        label="Message Name"
        name="messageName"
        [(ngModel)]="messageName"
        [options]="messageNames"
        (change)="cleanSearch()"
    ></cb-select>
    <mat-form-field class="flex">
        <mat-label>Order number</mat-label>
        <input
            type="text"
            aria-label="Search for a specific order number"
            [formControl]="orderNumberText"
            name="orderNumberSearch"
            matInput
        />
    </mat-form-field>
    <mat-form-field class="flex">
        <mat-label>Search Message History</mat-label>
        <input
            type="text"
            aria-label="Search Message History"
            [formControl]="searchText"
            name="logsSearch"
            matInput
        />
    </mat-form-field>
    <button [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon> more_horiz </mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="reindexLogs()">Fetch Latest Messages</button>
        <button mat-menu-item (click)="exportToCsv()">Export to CSV</button>
    </mat-menu>
</form>
<div class="chips-container flex-col">
    <mat-chip-set>
        <mat-chip (removed)="clearFilters()">
            <strong class="mat-body-2"> Clear All Filters </strong>
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip>
        @if (dateFrom != null) {
            <mat-chip (removed)="clearDateFrom()">
                <strong class="mat-body-2"> Date From - {{ dateFrom | date }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
        @if (dateTo != null) {
            <mat-chip (removed)="clearDateTo()">
                <strong class="mat-body-2"> Date To - {{ dateTo | date }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
        @if (!isNullOrWhiteSpace(orderNumberText.value)) {
            <mat-chip (removed)="orderNumberText.setValue('')">
                <strong class="mat-body-2"> OrderNumber - {{ orderNumberText.value }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
        @if (!isNullOrWhiteSpace(searchText.value)) {
            <mat-chip (removed)="searchText.setValue('')">
                <strong class="mat-body-2"> Query - {{ searchText.value }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
    </mat-chip-set>
</div>
<cb-table
    class="cb-margin-top flex"
    maxHeightOffset="312"
    [objectColumns]="columns"
    [loaded]="true"
    [fetch]="search()"
    [queryUpdated]="queryUpdated"
    [infiniteScrollEnabled]="infiniteScrollEnabled"
    [(results)]="logs"
    [(currentPage)]="currentPage"
>
    @for (message of logs; track message) {
        <tr cbTableRow>
            <cb-td-text [value]="message.eventDate | date: 'dd/MM/yyyy HH:mm:ss'"></cb-td-text>
            <cb-td-text [value]="message.name"></cb-td-text>
            <cb-td-text [value]="message.orderNumber"></cb-td-text>
            <cb-td-text [value]="message.eventMessage"></cb-td-text>
        </tr>
    }
</cb-table>
